(function () {
  if (window.__giftLockLoaded) return;
  window.__giftLockLoaded = true;

  var root = document.documentElement;
  var CHECKOUT = 'button[name="checkout"],input[name="checkout"],a[href*="/checkout"]';
  var SECTION_URL = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + '?sections=gift-check';

  function isLocked() {
    return root.classList.contains('gift-locked');
  }

  function refresh() {
    fetch(SECTION_URL + '&t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var m = (data['gift-check'] || '').match(/\[\[lines:(\d+);gift:(\d+)\]\]/);
        if (!m) return;
        var lines = Number(m[1]), gift = Number(m[2]);
        // Khóa khi giỏ có hàng và TẤT CẢ sản phẩm đều có template prodotti-omaggio
        root.classList.toggle('gift-locked', lines > 0 && gift === lines);
      })
      .catch(function () {});
  }

  // CSS chỉ làm mờ nút, phần này mới thực sự chặn click và submit
  document.addEventListener('click', function (e) {
    if (isLocked() && e.target.closest && e.target.closest(CHECKOUT)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', function (e) {
    if (!isLocked()) return;
    var f = e.target;
    if (f && f.action && /\/cart(\?|$)/.test(f.action) && f.querySelector('[name="checkout"]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Kiểm tra lại mỗi khi cart thay đổi (gộp nhiều request liên tiếp thành 1 lần)
  var timer;
  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 700);
  }

  var nativeFetch = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var url = a instanceof Request ? a.url : String(a || '');
    var p = nativeFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(scheduleRefresh, function () {});
    return p;
  };

  // Khi user bấm Back, trang lấy từ bfcache nên trạng thái có thể đã cũ
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });
})();

